const FINAL_STATUSES = [
    "Processing Started",
    "BI Content Generated",
    "TML Publishing",
    "TML Published",
    "Uploading to Data Source",
    "Data Uploaded",
    "Data Upload Failed",
    "Exporting to BI Platform",
    "Exported to BI Platform",
    "Export Failed",
    "Generating BI Content",
    "BI Content Generated",
    "BI Content Generation Failed",
    "Generating Semantic Assets",
    "Semantic Assets Generated",
    "Semantic Assets Generation Failed",
    "Saving Config",
    "Config Saved",
    "Config Save Failed",
    "Portal Preparing",
    "Portal Ready",
];

export const isProcessingStage = (stage?: string) =>
    stage === "Step 1 Processing" ||
    stage === "Step 2 Processing" ||
    stage === "Step 3 Processing" ||
    stage === "Step 4 Processing" ||
    stage === "Step 5 Processing" ||
    stage === "Step 7 Processing" ||
    stage === "Step 8 Processing" ||
    stage === "Step 9 Processing";

export const isFailedStage = (stage?: string) =>
    stage === "Step 1 Failed" ||
    stage === "Step 2 Failed" ||
    stage === "Step 3 Failed" ||
    stage === "Step 4 Failed" ||
    stage === "Step 5 Failed" ||
    stage === "Step 7 Failed" ||
    stage === "Step 8 Failed" ||
    stage === "Step 9 Failed";

export function getStepsCompletedCount(stage?: string): number {
    if (!stage) return 0;

    if (FINAL_STATUSES.includes(stage)) {
        return 10;
    }

    if (stage === "Step 2 Finished" || stage === "Step 2 Processing" || stage === "Step 2 Failed") {
        return 1;
    }

    const match = stage.match(/Step (\d+)/);
    if (!match) return 0;

    const stepNumber = Number(match[1]);

    if (stage.endsWith("Finished") || stage.endsWith("Failed") || stage.endsWith("Processing")) {
        return stepNumber;
    }

    return Math.max(stepNumber - 1, 0);
}

/** Hostname from a website URL for display (e.g. company column). */
export function companyDisplayNameFromWebsite(website: string | undefined | null): string {
    if (website == null || String(website).trim() === "") return "—";
    const raw = String(website).trim();
    try {
        const normalized = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
        const hostname = new URL(normalized).hostname;
        if (!hostname) return "—";
        return hostname.replace(/^www\./i, "");
    } catch {
        return raw.length > 48 ? `${raw.slice(0, 48)}…` : raw;
    }
}

/** Turn snake_case prompt config values into readable labels for the grid. */
export function humanizeSnakeCase(value: string | undefined | null): string {
    if (value == null || String(value).trim() === "") return "—";
    return String(value)
        .split(/[_\s]+/)
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(" ");
}

